import { preProdToken, userDevicesDetailsGetApi, userDevicesListGetApi, userDevicesStatsGetApi, userWSDevicesDetailsGetApi } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getDevices = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(userDevicesListGetApi + `${query || ""}`, config);

    return response;
};

export const getGsmDeviceDetails = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(userDevicesDetailsGetApi + `${id}/`, config);

    return response;
};

export const getWeatherStationDeviceDetails = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };

    const response = await axios.get(userWSDevicesDetailsGetApi + `${id}`, config);

    return response;
};

export const getDevicesSummary = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(userDevicesStatsGetApi, config);
    return response;
};
